import type { SVGProps } from 'react';

const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className='feather feather-calendar'
    fill='none'
    height={24}
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth={2}
    width={24}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect height={18} rx={2} ry={2} width={18} x={3} y={4} />
    <path d='M16 2v4M8 2v4M3 10h18' />
  </svg>
);
export default SvgCalendar;
